<template>
	<div class="formulate-v-calendar">
		<div class="mb-3">
			<v-date-picker
				v-model="vcalendar"
				mode="dateTime"
				:min-date="minDate"
				:max-date="maxDate"
				:popover="{ visibility: 'click' }"
				:model-config="modelConfig"
				is-range
				is-dark>
				<template #default="{ inputValue, inputEvents, isDragging }">
					<b-row>
						<b-col>
							<b-input-group>
								<template #prepend>
									<b-input-group-text>
										<font-awesome-icon :icon="['fas', 'calendar']" />
									</b-input-group-text>
								</template>
								<b-form-input
									:ref="`date_` + context.name + '_start'"
									:class="isDragging ? 'text-gray-600' : 'text-gray-900'"
									onkeydown="return false"
									placeholder="MM / DD / YYYY HH:MM"
									:value="displayValue(inputValue)"
									autocomplete="off"
									v-on="inputEvents.start"></b-form-input>
							</b-input-group>
						</b-col>
					</b-row>
				</template>
			</v-date-picker>
		</div>
	</div>
</template>

<script>
import auth from '@/Mixin/auth'

export default {
	mixins: [auth],
	props: {
		context: {
			type: Object,
			required: true
		}
	},
	data () {
		return  {
			auth: {},
			vcalendar: {},
			masks: {
				input: 'YYYY-MM-DD h:mm A'
			},
			modelConfig: {
				start: {
					timeAdjust: '00:00:00'
				},
				end: {
					timeAdjust: '00:00:00'
				}
			}
		}
	},
	computed: {
		minDate () {
			if (this.isStaff) {
				return null
			}

			if (this.context.attributes.min) {
				return this.parseDate(this.context.attributes.min)
			}

			return new Date()
		},
		maxDate () {
			if (this.isStaff) {
				return null
			}

			if (this.context.attributes.max) {
				return this.parseDate(this.context.attributes.max)
			}

			let maxDate = new Date()
			maxDate = maxDate.setFullYear(maxDate.getFullYear() + 1)

			return maxDate
		}
	},
	watch: {
		vcalendar (date, oldDate) {
			if (! date) {
				// eslint-disable-next-line vue/no-mutating-props
				this.context.model = {
					'start': null,
					'end': null
				}

				return
			}

			if (! date.start instanceof Date || isNaN(date.start)) {
				return
			}

			if (! date.end instanceof Date || isNaN(date.end)) {
				return
			}

			this.modelConfig = {}

			// eslint-disable-next-line vue/no-mutating-props
			this.context.model = {
				'start': this.formatDate(date.start),
				'end': this.formatDate(date.end)
			}

			this.$emit('change', this.context.model)
		}
	},
	mounted () {
		if (this.$page.props.hasOwnProperty('auth')) {
			this.auth = this.$page.props.auth
		}

		this.$nextTick(() => {
			this.vcalendar = {
				'start': this.parseDate(this.context.model.start),
				'end': this.parseDate(this.context.model.end)
			}
		})
	},
	methods: {
		formatDate (date) {
			if (! date) {
				return
			}

			let d = new Date(date),
				month = '' + (d.getMonth() + 1),
				day = '' + d.getDate(),
				year = d.getFullYear(),
				hour = d.getHours(),
				minute = d.getMinutes()

			if (month.length < 2) {
				month = '0' + month
			}

			if (day.length < 2) {
				day = '0' + day
			}

			return [year, month, day].join('-') + ' ' + hour + ':' + minute
		},
		parseDate (dateTimeString) {
			if (typeof dateTimeString !== 'string') {
				return dateTimeString
			}

			// If we pass in the date with dashes here then the timezone takes over
			// we're just replacing the dashes so date sees it as UTC since we don't care about time

			dateTimeString = dateTimeString.split(' ')
			const dateString = dateTimeString[0].split('-')
			const timeString = dateTimeString[1].split(':')

			let newDate = new Date()
			newDate.setFullYear(parseInt(dateString[0]))
			newDate.setMonth(parseInt(dateString[1]) - 1)
			newDate.setDate(parseInt(dateString[2]))
			newDate.setHours(parseInt(timeString[0]))
			newDate.setMinutes(parseInt(timeString[1]))

			return newDate
		},
		displayValue (inputValue) {
			if (inputValue.start && inputValue.end) {
				return inputValue.start + ' -> ' + inputValue.end
			}

			return 'Select a date range...'
		}
	}
}
</script>
